define('bizzabo/models/Track',[
    'bizzabo/bzapi',
    'bizzabo/consts',
    'backbone',
    'backbone-validation',
    'bizzabo/models/SyncedModel',
    'bizzabo/models/ValidationObject'
], function(
    BZAPI,
    Consts,
    Backbone,
    BackboneValidation,
    SyncedModel,
    ValidationObject
    ) {

    var Track = SyncedModel.extend({
        relationType: 'track',
        validationObject : undefined,
        defaults : {
            'index' : 0,
            'name' : ''
        },

        initialize : function() {
            this.validationObject = new ValidationObject(this);
        },

        validation : {
            name : {
                maxLength : 100,
                msg : 'Track name is too long (max 50)'
            },
            index : {
                range : [1, Consts.UI.agenda.MAX_NUM_OF_TRACKS],
                msg : 'Track index is out of range'
            }
        }
    });

    return Track;

});

